import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { Decimal, Int32Value, Int64Value, Date as ProtoDate, StringValue, Timestamp } from './proto';
export var decimalToNumber = function decimalToNumber(dec) {
  return Number(dec.num) / Math.pow(10, dec.scale);
};
export var decimalToString = function decimalToString(dec) {
  var sign = dec.num.startsWith('-') ? '-' : '';
  var numAbs = dec.num.replace('-', '');
  var intPartLength = numAbs.length > dec.scale ? numAbs.length - dec.scale : 0;
  var intPart = sign + (numAbs.slice(0, intPartLength) || '0');
  var decPart = dec.scale ? numAbs.padStart(dec.scale, '0').slice(-dec.scale) : undefined;

  if (!decPart || !parseInt(decPart, 10)) {
    return intPart;
  }

  return "".concat(intPart, ".").concat(decPart.replace(/^(\d*[1-9])0+$/, '$1'));
};
export var int32ToNumber = function int32ToNumber(int) {
  return int.value;
};
export var int64ToString = function int64ToString(int) {
  return int.value.toString();
};
export var stringToDecimal = function stringToDecimal(value) {
  var _value$split = value.split('.'),
      _value$split2 = _slicedToArray(_value$split, 2),
      a = _value$split2[0],
      _value$split2$ = _value$split2[1],
      b = _value$split2$ === void 0 ? '' : _value$split2$;

  var numStr = (a.trim() + b.trim()).replace(/^(-)?0+(\d)/, '$1$2');
  var decimal = Decimal.create({
    num: numStr,
    scale: b.length
  });
  return decimal;
};
export var numberToDecimal = function numberToDecimal(value) {
  return stringToDecimal(value.toString());
};
export var numberToInt32 = function numberToInt32(value) {
  return Int32Value.create({
    value: value
  });
};
export var stringToInt64 = function stringToInt64(value) {
  return Int64Value.create({
    value: value
  });
};
export var moneyToNumber = function moneyToNumber(money) {
  return (money === null || money === void 0 ? void 0 : money.value) && decimalToNumber(money.value);
};
export var timestampToMlSeconds = function timestampToMlSeconds(timestamp) {
  return Timestamp.toDate(timestamp).getTime();
};
export var dateToJSDate = function dateToJSDate(date) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (utc) {
    return new Date(Date.UTC(date.year, date.month - 1, date.day));
  }

  return new Date(date.year, date.month - 1, date.day);
};
export var mlSecondsToTimestamp = function mlSecondsToTimestamp(mlSeconds) {
  return Timestamp.fromDate(new Date(mlSeconds));
};
export var stringValueToStr = function stringValueToStr(value) {
  return value.value;
};
export var strToStringValue = function strToStringValue(str) {
  return StringValue.create({
    value: str
  });
};
export var dateToProtoDate = function dateToProtoDate(date) {
  return ProtoDate.fromJsDate(date);
};